
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BtnCheck from "@/components/scope/btn-check.vue";
import { priceRulesEl, partsQuantityRules } from "@common/src/utils/verify";
import { InjectFunction } from "@common/src/utils/decorator";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import t from "@common/src/i18n/t";
const staff = namespace("staff");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const inventory = namespace("inventory");
const setting = namespace("setting");
const common_base = namespace("common_base");
const common_inventory = namespace("common_inventory");

@InjectFunction("dayjs", "addCurrencyUnit", "emptyToLine", "splitThousands", "permit")
@Component({
  components: { BtnCheck, MyCheckbox }
})
export default class OutWarehouseEdit extends Vue {
  @setting.State serviceMode;
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @parts.Action getPartsList;
  @parts.Action getPartsDetail;
  @inventory.Action queryPartsQtyByWarehouseTree;
  @inventory.Action outWarehouseComplete;
  @inventory.Action queryInventoryAndNotice;
  @user.State userData;
  @base.Action getDictionaryList;
  @inventory.Action saveOutWarehouse;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_base.State showPlatformParts;
  @common_inventory.Action queryTransferWarehouseDetail;
  @common_inventory.Action createTransferWarehouse;
  @common_inventory.Action updateTransferWarehouse;
  @inventory.Action queryWarehouseByInventory;
  @setting.State fifoStatus;
  @setting.State productionBatchNoStatus;
  @inventory.Action queryPartsCostPrice;
  get currentFromShelfCodeTags() {
    return this.orderFormData.itemList.map(i => {
      return this.getFromShelfCodeTag(i);
    });
  }
  get currentToShelfCodeTags() {
    return this.orderFormData.itemList.map(i => {
      return this.getToShelfCodeTag(i);
    });
  }
  getFromShelfCodeTag(row, shelfCode?) {
    return (
      "" +
      row.partsCode +
      row.fromWarehouseCode +
      row.fromInboundBatchNo +
      row.fromProductionBatchNo +
      (shelfCode || row.fromWarehouseShelfCode)
    );
  }
  getToShelfCodeTag(row, shelfCode?) {
    return "" + row.partsCode + row.toWarehouseCode + (shelfCode || row.toWarehouseShelfCode);
  }
  get breadData() {
    return [
      { name: t("v210.warehouse-transfer-management"), path: "/inventory/transfer-warehouse-list" },
      { name: this.isAdd ? t("v210.new-stock-transfer-doc") : t("v210.edit-stock-transfer-doc") }
    ];
  }
  get isAdd() {
    return this.$route.name === "TransferWarehouseAdd";
  }
  orderFormDataRules = {
    outboundType: [{ required: true, message: t("v210801.pls-select-outbound-type"), trigger: "change" }]
  };
  disableInput(key, row) {
    switch (key) {
      case "fromWarehouseCode": {
        return !row.partsCode;
      }
      case "fromInboundBatchNo": {
        return !row.fromWarehouseCode;
      }
      case "fromProductionBatchNo": {
        return this.fifoStatus === "1" ? !row.fromInboundBatchNo : !row.fromWarehouseCode;
      }
      case "fromWarehouseShelfCode": {
        if (this.productionBatchNoStatus === "1") {
          return !row.fromProductionBatchNo;
        }
        return this.disableInput("fromProductionBatchNo", row);
      }
      case "toWarehouseCode": {
        return !row.partsCode;
      }
      case "toWarehouseShelfCode": {
        return !row.toWarehouseCode;
      }
      default:
        false;
    }
  }
  initWarehouseSelect(row) {
    this.queryWarehouseByInventory({
      partsCode: row.partsCode,
      dimension: 10
    }).then(({ data }) => {
      row.warehouseList = data.itemList;
      row.totalInventory = data.currentTotalInventory;
    });
  }
  initInboundBatchNoSelect(row) {
    this.queryWarehouseByInventory({
      partsCode: row.partsCode,
      warehouseCode: row.fromWarehouseCode || undefined,
      dimension: 20
    }).then(data => {
      row.inboundBatchList = data.data.itemList;
    });
  }
  initProductionBatchNoSelect(row) {
    this.queryWarehouseByInventory({
      partsCode: row.partsCode,
      warehouseCode: row.fromWarehouseCode || undefined,
      inboundBatchNo: row.fromInboundBatchNo || undefined,
      dimension: 30
    }).then(data => {
      row.productionBatchList = data.data.itemList;
    });
  }
  initShelfSelect(row) {
    this.queryWarehouseByInventory({
      partsCode: row.partsCode,
      warehouseCode: row.fromWarehouseCode || undefined,
      productionBatchNo: row.fromProductionBatchNo || undefined,
      inboundBatchNo: row.fromInboundBatchNo || undefined,
      dimension: 40
    }).then(data => {
      row.shelfList = data.data.itemList;
    });
  }
  async initToWarehouseSelect(row) {
    const data = await this.queryPartsQtyByWarehouseTree({
      partsCode: row.partsCode
    });
    row.toWarehouseList = data.data.warehouseList;
  }
  initToShelfSelect(row) {
    const selected = row.toWarehouseList.find(i => i.warehouseCode === row.toWarehouseCode);
    if (selected) {
      row.toShelfList = selected.shelfList;
    }
  }
  async handleChooseParts(val, row) {
    const partsItem = this.partsList.find(i => i.partsCode === val);
    row.partsUnit = partsItem.partsUnit;
    row.qty = "";
    this.initWarehouseSelect(row);
    row.fromWarehouseCode = "";
    row.fromInboundBatchNo = "";
    row.fromProductionBatchNo = "";
    row.fromWarehouseShelfCode = "";
    this.initToWarehouseSelect(row).then(() => {
      this.initToShelfSelect(row);
    });
    row.toWarehouseCode = "";
    row.toWarehouseShelfCode = "";
  }
  handleWarehouseChange(row) {
    if (this.fifoStatus === "1") {
      this.initInboundBatchNoSelect(row);
    } else if (this.productionBatchNoStatus === "1") {
      this.initProductionBatchNoSelect(row);
    } else {
      this.initShelfSelect(row);
    }
    row.fromInboundBatchNo = "";
    row.fromProductionBatchNo = "";
    row.fromWarehouseShelfCode = "";
  }
  handleInboundBatchNoChange(row) {
    if (this.productionBatchNoStatus === "1") {
      this.initProductionBatchNoSelect(row);
    } else {
      this.initShelfSelect(row);
    }
    row.fromProductionBatchNo = "";
    row.fromWarehouseShelfCode = "";
  }
  handleProductionBatchNoChange(row) {
    this.initShelfSelect(row);
    row.fromWarehouseShelfCode = "";
  }
  handleToWarehouseChange(row) {
    this.initToShelfSelect(row);
    row.toWarehouseShelfCode = "";
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  advisorList: any = [];
  orderFormData: any = {
    transferStaffUserCode: "",
    remark: "",
    itemList: [],
    immediatelyTransfer: false // 是否立即转移
  };
  definitionPartsData: any = {
    partsInfo: {},
    amount: "",
    qty: "",
    totalInventory: 0,
    partsCode: "",
    fromWarehouseCode: "",
    fromWarehouseShelfCode: "",
    warehouseList: [],
    fromInboundBatchNo: "",
    fromProductionBatchNo: "",
    inboundBatchList: [],
    productionBatchList: [],
    shelfList: [],
    toWarehouseCode: "",
    toWarehouseShelfCode: "",
    toWarehouseList: [],
    toShelfList: [],
    remark: "",
    manual: true
  };

  partsList: any[] = [];
  get transferCode() {
    return this.$route.params.id;
  }
  created() {
    this.setPBPX(52);
    this.init();
    this.handleAddParts(); // 默认添加第一行
  }
  async init() {
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    if (!this.isAdd) {
      await this.getPartsLists();
      this.queryTransferWarehouseDetail({
        transferCode: this.transferCode
      }).then(async data => {
        const itemList = data.data.itemList.map(item => {
          return {
            ...this.definitionPartsData,
            ...item,
            manual: false
          };
        });
        this.orderFormData = { ...data.data, itemList };
        this.orderFormData.itemList.forEach(item => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === item.partsCode;
            })
          ) {
            this.partsList.push({
              partsCode: item.partsCode,
              partsName: item.partsName
            });
          }
          this.initWarehouseSelect(item);
          if (this.fifoStatus === "1") {
            this.initInboundBatchNoSelect(item);
          }
          if (this.productionBatchNoStatus === "1") {
            this.initProductionBatchNoSelect(item);
          }
          this.initShelfSelect(item);
          this.initToWarehouseSelect(item).then(() => {
            this.initToShelfSelect(item);
          });
        });
      });
    } else {
      this.getPartsLists("");
      this.orderFormData.transferStaffUserCode = this.userData.userCode;
    }
  }
  getPartsLists(name = "") {
    return this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    }).then(data => {
      this.partsList = (data.data?.list || []).map(item => {
        item.partsNameDesc = item.partsCustomizeCode
          ? `${item.partsNameDesc}(${item.partsCustomizeCode})`
          : item.partsNameDesc;
        return item;
      });
    });
  }

  computedTotalAmount() {
    const partsTotal = this.orderFormData.itemList.reduce((preV, curV) => preV + Number(curV.amount), 0);
    console.log(partsTotal);
    if (Object.is(NaN, partsTotal)) {
      return this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    console.log(partsTotal);
    this.orderFormData.costAmount = partsTotal.i18nToFixed();
  }
  checkAddData(): boolean {
    if (this.orderFormData.itemList.length < 1) {
      this.$message.error(t("setting.add-least-one-component"));
      return false;
    }
    for (let index = 0; index < this.orderFormData.itemList.length; index++) {
      const element = this.orderFormData.itemList[index];
      if (!element.partsCode) {
        this.$message.error(t("v210.please-select-the-parts-to-be-transferred-first"));
        return false;
      }
      if (!element.qty) {
        this.$message.error(t("v210.please-fill-in-the-transfer-quantity"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.qty);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (
        !element.fromWarehouseCode ||
        !element.fromWarehouseShelfCode ||
        !element.toWarehouseCode ||
        !element.toWarehouseShelfCode
      ) {
        this.$message.error(t("v210.please-select-warehouse-/-location"));
        return false;
      }
    }
    return true;
  }
  operationName: string = "";

  handleSaveTransferWarehouse() {
    if (this.isAdd) {
      this.operationName = "add";
    } else {
      this.operationName = "edit";
    }
    this.emitSaveOutWarehouse();
  }
  emitSaveOutWarehouse() {
    (this.$refs["transferFormRef"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.btnStartLoading();
        const saveFunc = this.isAdd ? this.createTransferWarehouse : this.updateTransferWarehouse;
        this.orderFormData.immediatelyTransfer = this.operationName === "confirm";
        // 添加税率的两个字段
        const newOrderFormData = {
          ...this.orderFormData,
          itemList: this.orderFormData.itemList.map(o => {
            return {
              ...o,
              fromTaxIncluded: o.inboundBatchList.find(_ => _.code === o.fromInboundBatchNo)?.taxIncluded,
              fromTaxRate: o.inboundBatchList.find(_ => _.code === o.fromInboundBatchNo)?.taxRate
            };
          })
        };
        this.btnStartLoading();
        saveFunc(newOrderFormData)
          .then(data => {
            if (this.operationName === "add" || this.operationName === "edit") {
              this.$message.success(t("v210.stock-transfer-order-saved"));
            } else if (this.operationName === "confirm") {
              this.$message.success(t("v210.stock-transfer-doc-moved"));
              this.showInConfirmTips = false;
            }
            this.$router.push(`/inventory/transfer-warehouse-view/${data.data.transferCode}`);
          })
          .finally(() => {
            this.btnStopLoading();
          });
      } else {
        console.log("error submit!!");
      }
    });
  }
  handleAddParts() {
    this.orderFormData.itemList.push(Object.assign({}, this.definitionPartsData));
  }
  deleteItem(key, index) {
    this.orderFormData[key].splice(index, 1);
  }
  handleShelfSelectFocus(row, type) {
    if (type === "warehouse") {
      if (!row.fromWarehouseCode) {
        this.$message.error(t("v210.please-select-the-original-warehouse-first"));
      }
    } else {
      if (!row.toWarehouseCode) {
        this.$message.error(t("v210.please-select-the-target-warehouse-first"));
      }
    }
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  showInConfirmTips: boolean = false;
  handleShowConfirmDialog() {
    this.showInConfirmTips = true;
  }
  handleConfirmTransfer() {
    this.operationName = "confirm";
    this.emitSaveOutWarehouse();
  }
}
